import React, { useState, useEffect, useRef } from 'react';
import { viewPoints } from '../../../util/viewPoints';

const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState('default');
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 400) {
        setBreakpoint('mobile');
      } else {
        setBreakpoint('default');
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return breakpoint;
};

const getPointStyle = (point, scale, isBack, breakpoint) => {
  const position = breakpoint === 'mobile' ? point.mobilePosition : point.dotPosition;

  const spacing = position.spacing * scale;
  const topOffset = position.top * scale;
  const sideOffset = position.side * scale;

  if (isBack) {
    return {
      top: `${topOffset}px`,
      right: `-${spacing}px`
    };
  } else {
    return {
      top: `${topOffset}px`,
      left: `${sideOffset}px`
    };
  }
};

const PopupBtmPartRepair = ({ setisShowPartRepair, setisCompletePartRepair, carInfo, setcarInfo }) => {
  const [selectedParts, setSelectedParts] = useState(carInfo.carRepairPart || []);
  const [selectedView, setSelectedView] = useState('front');
  const [scale, setScale] = useState(1);
  const breakpoint = useBreakpoint();
  const containerRef = useRef(null);
  
  const ORIGINAL_WIDTHS = {
    front: 500,
    back: 500,
    top: 500,
    driver: 500,
    passenger: 500
  };

  const getPositionStyle = (point, scale) => {
    const { x, y, mobileX, mobileY } = point;
    const posX = breakpoint === 'mobile' && mobileX ? mobileX : x;
    const posY = breakpoint === 'mobile' && mobileY ? mobileY : y;

    return {
      top: `${posY * scale}px`,
      left: `${posX * scale}px`
    };
  };

  useEffect(() => {
    const updateScale = () => {
      if (containerRef.current) {
        const currentWidth = containerRef.current.offsetWidth;
        setScale(currentWidth / ORIGINAL_WIDTHS[selectedView]);
      }
    };

    updateScale();

    const resizeObserver = new ResizeObserver(updateScale);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, [selectedView]);

  const handlePartSelection = (partName) => {
    setSelectedParts(prev => {
      const newSelection = prev.includes(partName)
        ? prev.filter(p => p !== partName)
        : [...prev, partName];

      return newSelection;
    });
  };

  useEffect(() => {
    // Enable complete button if any parts are selected
    // setisCompletePartRepair(selectedParts.length > 0);
  }, [selectedParts, setisCompletePartRepair]);

  const handleComplete = () => {
    if (selectedParts.length > 0) {
      setcarInfo(prevInfo => ({
        ...prevInfo,
        carRepairPart: selectedParts
      }));
      setisShowPartRepair(false);
      setisCompletePartRepair(true);
    }
  };

  const viewButtons = [
    { id: 'front', text: '앞쪽', image: 'car01.png' },
    { id: 'back', text: '뒷쪽', image: 'car02.png' },
    { id: 'top', text: '위쪽', image: 'car03.png' },
    { id: 'driver', text: '운전석', image: 'car04.png' },
    { id: 'passenger', text: '조수석', image: 'car05.png' }
  ];

  // handleCancel 함수도 같은 방식으로 수정
  const handleCancel = () => {
    setisShowPartRepair(false);
  };


  // 스와이프 관련 상태
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const dragHandleRef = useRef(null); // 드래그 핸들(상단 바)을 위한 ref

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    // dragHandleRef가 터치 이벤트의 시작점을 포함하고 있는지 확인
    if (dragHandleRef.current?.contains(e.target)) {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientY);
    }
  };

  const onTouchMove = (e) => {
    // touchStart가 있을 때만 동작 (즉, 드래그 핸들에서 시작된 터치일 때만)
    if (touchStart) {
      setTouchEnd(e.targetTouches[0].clientY);
    }
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchEnd - touchStart;
    const isDownSwipe = distance > minSwipeDistance;
    
    if (isDownSwipe) {
      setisShowPartRepair(false);
    }
  };

  return (
    <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10">
      <div 
        className="bg-white w-full pb-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md max-h-[calc(100%-67px)] overflow-y-auto relative"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {/* 드래그 핸들 영역에 ref 추가 */}
        <button 
          ref={dragHandleRef}
          className="absolute top-0 left-0 flex justify-center w-full h-10 pt-4 m-auto rounded-xl"
        >
          <span className="w-10 h-1 bg-[#E1E2E4] rounded-xl"></span>
        </button>

        <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] pl-5 pb-2">
          사고 부위를 선택해주세요
        </h3>
        <p className="text-[#878A92] text-base mb-6 pl-5">진단 수리를 위한 사고 부위를 선택해주세요</p>

        <div className="flex justify-center w-full gap-2 px-6">
          {viewButtons.map(button => (
            <button
              key={button.id}
              className={`text-[13px] w-full h-[34px] flex justify-center items-center rounded-[36px] ${
                selectedView === button.id ? 'bg-[#313A4C] text-white' : 'bg-[#F4F4F5] text-[#878A92]'
              }`}
              onClick={() => setSelectedView(button.id)}
            >
              {button.text}
            </button>
          ))}
        </div>

        <div className="relative w-full px-5 max-w-[670px] m-auto" ref={containerRef}>
          {viewPoints[selectedView].map((point) => (
            <div
              key={point.id}
              className="absolute flex items-center justify-between"
              style={getPositionStyle(point, scale)}
            >
              <button 
                className="relative"
                onClick={() => handlePartSelection(point.name)}
              >
                <span 
                  className={`rounded-full block absolute ${
                    selectedParts.includes(point.name) ? 'bg-[#0d99ff]' : 'bg-[#667085]'
                  }`}
                  style={{
                    width: `${breakpoint === 'mobile' ? 4 : 5 * scale}px`,
                    height: `${breakpoint === 'mobile' ? 4 : 5 * scale}px`,
                    ...getPointStyle(point, scale, selectedView === 'back', breakpoint)
                  }}
                />
                <p 
                  className={`inline-flex justify-center items-center text-white rounded-full ${
                    selectedParts.includes(point.name) ? 'bg-[#0d99ff]' : 'bg-[#667085]'
                  }`}
                  style={{
                    padding: `${breakpoint === 'mobile' ? 2 : 3 * scale}px ${breakpoint === 'mobile' ? 4 : 6 * scale}px`,
                    fontSize: `${breakpoint === 'mobile' ? 12 : 14 * scale}px`
                  }}
                >
                  {point.name.includes('(') ? point.name.split('(')[0] : point.name}
                </p>
              </button>
            </div>
          ))}

          <img 
            src={`/assets/img/car/${viewButtons.find(b => b.id === selectedView).image}`} 
            alt={selectedView} 
            className="w-full"
          />
        </div>

        <div className="h-[calc(100vh-480px)] px-5 pb-5 overflow-auto">
          {Object.entries(viewPoints).map(([category, items]) => (
            <div key={category}>
              <p className="font-medium text-[13px] text-[#878A92] mt-[16px] mb-[10px]">
                {
                  selectedView === category && (
                    category === 'front' ? '앞쪽' :
                    category === 'back' ? '뒷쪽' :
                    category === 'top' ? '위쪽' :
                    category === 'driver' ? '운전석' :
                    category === 'passenger' ? '조수석' :
                    null
                  )
                }
              </p>
              <div className="space-y-2">
                {items.map((item) => (
                  selectedView === category && (
                    <label key={item.id} className="flex items-center space-x-2">
                      <input 
                        type="checkbox"
                        className="fixed left-[-9999px]"
                        checked={selectedParts.includes(item.name)}
                        onChange={() => handlePartSelection(item.name)}
                      />
                      {selectedParts.includes(item.name) ? (
                        <>
                          <img src="/assets/img/ico_check_on.svg" alt="check" />
                          <span className="text-sm text-[#1B1C1E]">{item.name}</span>
                        </>
                      ) : (
                        <>
                          <i className="block border border-[#D0D5DD] w-4 h-4 rounded-[4px]"></i>
                          <span className="text-sm text-[#878A92]">{item.name}</span>
                        </>
                      )}
                    </label>
                  )
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-between gap-[10px] border-t border-solid border-[#DBDCDF] pt-5 pl-5 pr-5">
          <button
            className="flex items-center justify-center w-full h-[52px] rounded-lg bg-[#F4F4F5] text-[#313A4C] font-semibold"
            onClick={() => handleCancel()}
          >
            취소
          </button>
          <button
            className={`flex items-center justify-center w-full h-[52px] rounded-lg ${
              selectedParts.length > 0 ? 'bg-[#313A4C]' : 'bg-[#E1E2E4]'
            } text-white cursor-pointer font-semibold`}
            onClick={handleComplete}
            disabled={selectedParts.length === 0}
          >
            완료
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupBtmPartRepair;